import PartnershipBannersPage from './PartnershipBannersPage';

export default PartnershipBannersPage;
